import {
  FailedEmailsDto,
  FailedEmailsModel,
  mapFailedEmailsDtoToModel,
  mapFailedEmailsModelToDto,
} from 'api/dto/FailedEmails.dto';

import { EmailTemplateDto } from './EmailTemplate.dto';

export type DeliveryStatisticDto = {
  delivered: string[];
  failed: FailedEmailsDto[];
  enqueued: string[];
  emailTemplate?: EmailTemplateDto;
};

export type DeliveryStatisticModel = {
  emailTemplateId: number;
  emailTemplateJobId: number;
  delivered: string[];
  failed: FailedEmailsModel[];
  enqueued: string[];
};

export function mapDeliveryStatisticModelToDto(
  model: DeliveryStatisticModel,
): DeliveryStatisticDto {
  return {
    delivered: model.delivered,
    failed: model.failed.map(mapFailedEmailsModelToDto),
    enqueued: model.enqueued,
  };
}

export function mapDeliveryStatisticDtoToModel(dto: DeliveryStatisticDto): DeliveryStatisticModel {
  return {
    delivered: dto.delivered,
    failed: dto.failed.map(mapFailedEmailsDtoToModel),
    enqueued: dto.enqueued,
    emailTemplateId: dto.emailTemplate.id,
    emailTemplateJobId: dto.emailTemplate.job ? dto.emailTemplate.job.id : null,
  };
}
